import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errorMsg } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/Panel";
import { VehiculoForm, VEHICULO_VACIO, validarVehiculo } from "@/components/VehiculoForm";
import { CheckCircle2, X } from "lucide-react";

export default function VehiculoCrear() {
  const navigate = useNavigate();
  const clientePre = useLocation().state?.clienteId || "";
  const [valor, setValor] = useState({ ...VEHICULO_VACIO, cliente_id: clientePre });
  const [errores, setErrores] = useState({});
  const [exito, setExito] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [modelos, setModelos] = useState([]);

  useEffect(() => {
    (async () => {
      const [c, m] = await Promise.all([api.get("/clientes"), api.get("/modelos")]);
      setClientes(c.data); setModelos(m.data);
    })();
  }, []);

  const guardar = async () => {
    const e = validarVehiculo(valor);
    setErrores(e);
    if (Object.keys(e).length) return;
    setGuardando(true);
    try {
      const { data } = await api.post("/vehiculos", { ...valor, anio: parseInt(valor.anio, 10) });
      toast.success("Vehículo creado de forma exitosa");
      navigate("/trabajos/ingresar", { state: { vehiculoId: data.id } });
    } catch (err) {
      const msg = errorMsg(err);
      if (err?.response?.status === 409) {
        setErrores(msg.toLowerCase().includes("chasis") ? { chasis: msg } : { placa: msg });
      }
      toast.error(msg);
    } finally { setGuardando(false); }
  };

  return (
    <div data-testid="vehiculo-crear-page" className="space-y-4">
      {exito && (
        <div data-testid="vehiculo-exito-alert"
          className="flex items-center gap-2 rounded-lg border border-green-300 bg-green-50 px-4 py-3 text-sm text-green-800">
          <CheckCircle2 size={18} className="text-green-600 shrink-0" />
          Vehículo creado de forma exitosa
          <button data-testid="vehiculo-exito-cerrar" onClick={() => setExito(false)} className="ml-auto text-green-700 hover:text-green-900">
            <X size={16} />
          </button>
        </div>
      )}
      <Panel titulo="Creación de Vehículo" testId="vehiculo-crear-panel">
        <VehiculoForm valor={valor} onChange={(v) => { setValor(v); setExito(false); }}
          errores={errores} clientes={clientes} modelos={modelos} />
        <div className="flex justify-end mt-6">
          <Button data-testid="vehiculo-agregar-btn" onClick={guardar} disabled={guardando}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-8">
            {guardando ? "Guardando..." : "Agregar"}
          </Button>
        </div>
      </Panel>
    </div>
  );
}
